import { useCallback } from 'react';
import { getUrl } from 'aws-amplify/storage';

export const useFilePath = () => {
  const buildImagePath = useCallback(async (imagePath, assetId, prefix) => {
    if (imagePath.includes('https')) {
      return imagePath;
    }
    const imageURL = await getUrl({
      path: `files/${
        imagePath.includes('/')
          ? imagePath
          : `${prefix}/images/${assetId}/${imagePath}`
      }`,
    });

    return imageURL.url.href;
  }, []);

  const buildBackgroundPath = useCallback(async (backPath, displayId) => {
    const imageURL = await getUrl({
      path: `files/display/backgrounds/${displayId}/${decodeURIComponent(
        backPath,
      )}`,
    });
    return imageURL.url.href;
  }, []);

  const buildDisplayPath = useCallback(img => {
    return `${
      process.env.REACT_APP_STORAGE_BASE_URL
    }/display/frames/${encodeURIComponent(img)}`;
  }, []);

  const getFilename = useCallback(docPath => {
    if (docPath.includes('https')) {
      return decodeURIComponent(docPath.split('/')[4].split('?')[0]);
    }
    return docPath.includes('/') ? docPath.split('/').at(-1) : docPath;
  }, []);

  const buildIconPath = useCallback(icon => {
    return `${process.env.REACT_APP_STORAGE_BASE_URL}/icons/${icon}`;
  }, []);

  const buildDocPath = useCallback(async (docPath, typePrefix, typeId) => {
    if (!docPath) return '';

    const docUrl = await getUrl({
      path: `files/${
        docPath.includes('/')
          ? docPath
          : `${typePrefix}/docs/${typeId}/${docPath}`
      }`,
    });

    return docUrl.url.href;
  }, []);

  return {
    buildImagePath,
    buildDocPath,
    getFilename,
    buildBackgroundPath,
    buildDisplayPath,
    buildIconPath,
  };
};
